import { Controller } from '@hotwired/stimulus'
import Chart from 'chart.js/auto'
import ChartStyles from '../../../utils/chart_styles'

// By-service chart on the retention management report: open at-risk cases
// against services cancelled in the period, server-rendered into data
// values. The MRR arrays are cents, surfaced as each bar's tooltip detail.
export default class extends Controller {
  static targets = ['chart']

  static values = {
    labels: Array,
    atRisk: Array,
    cancelled: Array,
    mrrAtRisk: Array,
    mrrLost: Array
  }

  connect() {
    const mrr = [this.mrrAtRiskValue, this.mrrLostValue]
    const suffix = ['/mo at risk', '/mo lost']

    this.chart = new Chart(this.chartTarget, {
      type: 'bar',
      data: {
        labels: this.labelsValue,
        datasets: [
          { label: 'At Risk', data: this.atRiskValue, backgroundColor: ChartStyles.colors.yellow },
          { label: 'Cancelled', data: this.cancelledValue, backgroundColor: ChartStyles.colors.red }
        ]
      },
      options: {
        responsive: true,
        maintainAspectRatio: false,
        plugins: {
          legend: { position: 'bottom' },
          tooltip: {
            callbacks: {
              afterLabel: (context) => {
                const cents = mrr[context.datasetIndex]?.[context.dataIndex]
                if (!cents) return null

                const dollars = (cents / 100).toLocaleString('en-US', { style: 'currency', currency: 'USD' })
                return `${dollars}${suffix[context.datasetIndex]}`
              }
            }
          }
        },
        scales: {
          y: { beginAtZero: true, ticks: { precision: 0 } }
        }
      }
    })
  }

  disconnect() {
    this.chart?.destroy()
  }
}
